import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { CheckList, Chip, DemoCaption, PhoneFrame } from './shared';

// Section 7 — KPI Scorecards. Demonstration figures are labelled illustrative.
export const CompassKpi = ({ sp }) => (
  <section aria-labelledby="compass-kpi-heading" data-testid="compass-kpi" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal className="order-last lg:order-first">
          <PhoneFrame shot={sp.shots.kpiMobile} className="mx-auto max-w-[300px]" />
          <DemoCaption />
        </Reveal>
        <Reveal delay={0.12}>
          <SectionHeader
            align="left"
            eyebrow="Performance"
            title="Track the numbers that matter"
            description={sp.kpiCopy}
            testid="compass-kpi-header"
          />
          <div className="mt-6 flex flex-wrap gap-2" aria-label="KPI categories">
            {(sp.kpiCategories || []).map((category) => (
              <Chip key={category}>{category}</Chip>
            ))}
          </div>
          <div className="mt-8">
            <CheckList items={sp.kpiPoints || []} testid="compass-kpi-points" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
